<script setup lang="ts">
    import { onMounted } from 'vue';
import { useFloatingElementsQueue } from '../../Composables/floating-elements-queue';

    const { currentElement } = useFloatingElementsQueue();

    onMounted(() => console.log('FloatingElementsQueue mounted'));
</script>
<template>
    <div v-if="currentElement" :class="['floating-elements-queue', currentElement.position]">
        <component class="element" :is="currentElement.component"/>
    </div>
</template>
<style lang="scss">

.floating-elements-queue {
    position: fixed;
    z-index: 999999;
    display: flex;
    padding: 15px;

    @media screen and (max-width: 768px) {
        width: 100%;
    }

    &[class*="top-"] {
        top: 0;
    }

    &[class*="bottom-"] {
        bottom: 0;
    }

    &[class*="-left"] {
        left: 0;
    }

    &[class*="-right"] {
        right: 0;
    }

    &[class*="-center"] {
        left: 50%;
        transform: translateX(-50%);
    }
}

</style>